// import Textarea from 'react-native-textarea';
import React, { useState, useEffect, useRef } from "react";
import { Image, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Icons } from "../../assets";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { useNavigation } from "@react-navigation/native";
import { useGlobalState } from "../../shared/state";
import { I18N, sleep } from "../../shared/util";
import { Fonts, Styles } from "../../styles";

import useBirkenstockPrint from "../Web/useBirkenstockPrint";
import BirkenstockLabel from "../../components/BirkenstockLabel";

const System: React.FC = (): JSX.Element => {
  const [currentScanner] = useGlobalState("currentScanner");
  const [language] = useGlobalState("language");
  const [, setRoute] = useGlobalState("currentScreen");
  const [birkenstockSummary] = useGlobalState("birkenstockSummary");
  const [, setRegion] = useGlobalState("region");

  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);

  const navigation = useNavigation();
  const i18n = I18N(language);
  const countryList = ["Austria", "Germany", "Switzerland", "Netherlands", "Belgium", "Italy", "Spain", "France"];

  const navigate = (route: string | undefined, options: any = undefined) => {
    if (route) {
      navigation.push(route, options);
      setRoute(route);
    }
  };

  useEffect(() => {
    if (sendButtonDisabled) sleep(10000).then(() => setSendButtonDisabled(false));
  }, [sendButtonDisabled]);

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (country: string) => {
    setSelected(country);
    setRegion(country);
    setOpen(false);
    // onSelect(country);
  };

  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = useBirkenstockPrint(printRef);

  return (
    <LayoutWrapper showHeaderCloseButton={false} showMenuButtons={false} hideInfoButton={true} hideBackButton>
      <View style={[Styles.contentWrapperFull, Styles.column]}>
        <View style={styles.wrapper}>
          <View style={styles.header}>
            <Text style={[Fonts.pageTitle, { fontSize: 40, fontFamily: "Birkentype", color: "#0e2288" }]}>{i18n.t("support.caption").toUpperCase()}</Text>
          </View>
          <View style={[styles.container, open && styles.containerOpenTint, open && styles.containerOpenLayout]}>
            <View style={[styles.contentWrapper, open ? styles.contentWrapperOpen : styles.contentWrapperClosed]}>
              {!open ? (
                <View style={styles.closedButtonsRow}>
                  <TouchableOpacity
                    style={[styles.mapPinButtonBase, styles.mapPinButtonClosed]}
                    onPress={() => setOpen(true)}
                    activeOpacity={0.85}
                  >
                    <Image source={Icons.mapPinIcon} style={styles.mapPinImage} />
                  </TouchableOpacity>
                  <TouchableOpacity style={[styles.button, styles.printButton]} onPress={() => handlePrint()}>
                    <Text style={[styles.text, styles.printButtonText]}>RE-PRINT PREVIOUS SCAN</Text>
                  </TouchableOpacity>
                </View>
              ) : (
                <View style={styles.selectionCluster}>
                  <View style={styles.mapPinColumnOpen}>
                    <TouchableOpacity
                      style={[styles.mapPinButtonBase, styles.mapPinButtonOpen]}
                      onPress={() => setOpen(false)}
                      activeOpacity={0.85}
                    >
                      <Image source={Icons.mapPinIcon} style={[styles.mapPinImage, styles.mapPinImageOpen]} />
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.countryBackButton} onPress={() => setOpen(false)} activeOpacity={0.85}>
                      <Image source={Icons.backArrowFilledIcon} style={styles.countryBackIcon} />
                    </TouchableOpacity>
                  </View>
                  <View style={styles.dropdown}>
                    <ScrollView
                      style={styles.scroll}
                      contentContainerStyle={styles.scrollContent}
                      showsVerticalScrollIndicator
                    >
                      {countryList.map((country) => (
                        <TouchableOpacity key={country} style={styles.item} onPress={() => handleSelect(country)}>
                          <Text style={styles.countryItemText}>{country}</Text>
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  </View>
                </View>
              )}
            </View>

            {!open && (
              <>
                <View style={{ height: "10%", marginTop: "3%" }}>
                  <Text style={[styles.text, { fontSize: 24, fontFamily: "Geist-Light", fontWeight: "bold" }]}>
                    CURRENT COUNTRY SELECTION: {selected?.toUpperCase()}
                  </Text>
                </View>
                <View style={{ height: "10%" }}>
                  <Text style={[styles.text, { fontSize: 16, fontFamily: "Geist-Light" }]}>Scanner ID: {currentScanner["scanner-name"]}</Text>
                </View>
                <View style={{ height: "10%" }}>
                  <Text style={[styles.text, { fontSize: 16, fontFamily: "Geist-Light" }]}>
                    Problem? Contact <Text style={{ textDecorationLine: "underline" }}>it@service.birkenstock.com</Text>
                  </Text>
                </View>
              </>
            )}
          </View>
          {/* {!open && ( */}
            <View style={{ height: "15%", marginTop: "5%", justifyContent: "center", alignItems: "center" }}>
              <TouchableOpacity style={[styles.button, { width: "5%", padding: 1.5, height: "65%", justifyContent: "center", alignItems: "center" }]} onPress={() => navigate("Home")}>
                <Image source={Icons.homeIcon} style={{ width: "90%", height: "90%", borderRadius: 10, resizeMode: "contain", padding: 0 }} />
              </TouchableOpacity>
            </View>
          {/* )} */}
        </View>
      </View>
      <View pointerEvents="none" style={styles.printBuffer}>
        {/* Hidden in UI – used only for printing */}
        <div id="print-birkenstock-label" ref={printRef} style={{ position: "absolute", top: -9999, left: -9999 }}>
          {birkenstockSummary && <BirkenstockLabel summary={birkenstockSummary} />}
        </div>
      </View>
    </LayoutWrapper>
  );
};

export default System;

const styles = StyleSheet.create({
  wrapper: {
    height: "100%",
    width: "85%",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  header: {
    height: "12%",
    width: "100%",
    paddingTop: "2%",
    paddingBottom: "3%",
    paddingLeft: "2%",
  },
  contentWrapper: {
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  contentWrapperClosed: {
    minHeight: "26%",
    paddingTop: "5%",
    paddingBottom: "2%",
  },
  contentWrapperOpen: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    paddingTop: "4%",
    paddingBottom: "3%",
    paddingHorizontal: "4%",
  },
  closedButtonsRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "94%",
    maxWidth: 720,
    alignSelf: "center",
  },
  selectionCluster: {
    flex: 1,
    minHeight: 0,
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "center",
    width: "100%",
    maxWidth: 450,
    alignSelf: "center",
  },
  container: {
    width: "60%",
    height: "45%",
    alignSelf: "center",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#e8e9eb",
    boxShadow: "0px 2px 8px #00000014",
  },
  /** Wrapper stays the card; light grey tint when country list is open (list reads on top). */
  containerOpenTint: {
    backgroundColor: "#f0f1f3",
    borderColor: "#e0e2e5",
  },
  containerOpenLayout: {
    justifyContent: "flex-start",
  },
  mapPinColumnOpen: {
    width: 56,
    marginRight: 12,
    alignItems: "stretch",
    alignSelf: "flex-start",
    height: "100%",
    justifyContent: "space-between",
  },
  mapPinButtonBase: {
    borderRadius: 10,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 6px #00000029",
  },
  mapPinButtonClosed: {
    width: 96,
    height: 96,
    backgroundColor: "#fff",
    padding: 6,
  },
  mapPinButtonOpen: {
    width: 56,
    height: 56,
    backgroundColor: "#0e2288",
    padding: 6,
    marginBottom: 8,
  },
  mapPinImage: {
    width: "100%",
    height: "100%",
    resizeMode: "contain",
  },
  mapPinImageOpen: {
    tintColor: "#ffffff",
  },
  countryBackButton: {
    width: 56,
    height: 56,
    borderRadius: 10,
    backgroundColor: "#5c5c5c",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 6px #00000029",
  },
  countryBackIcon: {
    width: "50%",
    height: "50%",
    resizeMode: "contain",
    tintColor: "#ffffff",
  },
  button: {
    padding: 12,
    borderRadius: 10,
    backgroundColor: "#fff",
    boxShadow: "0px 4px 6px #00000029",
  },
  /** Same height as square map pin (~2.7× width); caps so it does not dominate narrow screens. */
  printButton: {
    flex: 1,
    marginLeft: 14,
    height: 96,
    minHeight: 96,
    maxHeight: 96,
    maxWidth: 300,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 12,
  },
  printButtonText: {
    fontSize: 22,
    fontFamily: "Birkentype",
    textAlign: "center",
    lineHeight: 28,
  },
  dropdown: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    maxWidth: 260,
    alignSelf: "stretch",
    backgroundColor: "#ffffff",
    overflow: "hidden",
    borderRadius: 4,
    boxShadow: "0px 2px 10px #00000018",
  },
  scroll: {
    flex: 1,
    backgroundColor: "#ffffff",
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: 8,
  },
  item: {
    paddingVertical: 12,
    paddingHorizontal: 10,
  },
  countryItemText: {
    fontFamily: "Geist-Light",
    fontWeight: "600",
    fontSize: 17,
    color: "#000000",
    textDecorationLine: "underline",
  },
  text: {
    color: "#0e2288",
    fontFamily: "Geist-Light",
  },
  printBuffer: {
    width: 0,
    height: 0,
    overflow: "hidden",
  },
});
